import { useLocation } from "react-router-dom";
import Header from "../components/partials/header";
import ShinnyHeader from "../components/partials/shinyHeader";
import GameHeader from "../components/partials/gameHeader";
import MarketHeader from "../components/partials/marketHeader";

const useHeader = () => {
    const location = useLocation();
    const pageName = location.pathname.substring(1) || "Home";
    switch (pageName) {
        case "Home":
            return <Header />;
        case "openPack":
            return null;
        case "previewPack":
            return null;
        case "ballcano":
            return null;
        case "roulette":
            return null;
        case "roulette/join":
            return null;
        case "game":
            return <GameHeader title={pageName}/>;
        case "market":
            return <MarketHeader/>;
        default:
            return <ShinnyHeader title={pageName}/>;
    }
}

export default useHeader;